import { validateCnpj } from 'utils';
import * as yup from 'yup';

export const validationSchema = yup
  .object()
  .shape({
    responsibleName: yup
      .string()
      .min(2, 'Preencha o campo para prosseguir')
      .max(255, 'Deve ter no máximo 255 caracteres')
      .test(
        'name',
        'Preencha dados validos para prosseguir',
        (val) =>
          val.includes(' ') &&
          val.split(' ')[0].length >= 2 &&
          val.split(' ')[1].length >= 1
      )
      .required('Preencha o campo para prosseguir'),
    responsiblePhone: yup
      .string()
      .min(14, 'Preencha o campo para prosseguir')
      .required('Preencha dados validos para prosseguir'),
    socialEnterpriseName: yup
      .string()
      .min(2, 'Preencha o campo para prosseguir')
      .max(255, 'Deve ter no máximo 255 caracteres')
      .required('Preencha o campo para prosseguir'),
    enterpriseCnpj: yup
      .string()
      .min(18, 'Preencha o campo para prosseguir')
      .test('cnpj', 'Preencha dados validos para prosseguir', (val) =>
        validateCnpj(val)
      )
      .required('Preencha o campo para proseguir'),
  })
  .required();
